import React from 'react';
import ViewEstimate from '../view/ViewEstimate';
import ViewBase from '../view/ViewBase';
import { infoMenus } from '../ref/refINFO';

const PageEstimate = () => {

    //----------------------------------------------------------------- Working Function Area Start
    //----------------------------------------------------------------- Working Function Area End

    //----------------------------------------------------------------- useEffect Area Start
    //----------------------------------------------------------------- useEffect Area End

    //----------------------------------------------------------------- Header Button Area Start
    //----------------------------------------------------------------- Header Button Area End
    const propDatas = {
        curPath: infoMenus[5].path,
    }

    return (
        <>
            <ViewBase {...propDatas} ViewContainer={ViewEstimate}/>
        </>
    );
}

export default PageEstimate;